var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propChildren, propId, propNumber, propStr, } from '../../../helpers/custom-prop-types';
/**
 * テキストの文字数カウントを行うコンポーネント
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
const CountText = (props) => {
    const { errorClassName, gt, limit, prefixText, suffixText, value, valueComponent: ValueComponent } = props, otherProps = __rest(props
    // 文字数カウント
    , ["errorClassName", "gt", "limit", "prefixText", "suffixText", "value", "valueComponent"]);
    // 文字数カウント
    const count = value.length;
    // 文字数が制限値を超えている
    const isExceeded = limit !== null && limit < count;
    if (count < gt) {
        return null;
    }
    if (ValueComponent) {
        return (_jsxs(_Fragment, { children: [prefixText, _jsx(ValueComponent, Object.assign({}, otherProps, { children: count })), suffixText] }));
    }
    return (_jsxs(_Fragment, { children: [prefixText, _jsx("b", Object.assign({ className: isExceeded ? errorClassName : '' }, { children: count })), suffixText] }));
};
CountText.propTypes = {
    errorClassName: propStr(),
    gt: propNumber(),
    limit: propNumber(),
    prefixText: propChildren(),
    suffixText: propChildren(),
    value: propId(),
    valueComponent: propStr(),
};
CountText.defaultProps = {
    errorClassName: 'font-alert',
    gt: 0,
    limit: null,
    prefixText: '現在の文字数：',
    suffixText: '文字',
    value: '',
    valueComponent: undefined,
};
export default CountText;
